import { getTopBannerLayoutWithStore } from '@bingads-webui-react/notification-center';
import { NotificationStore } from '../notification-store';

import { MiniCalloutWrapper } from './mini-callout';

export const getTopBannerLayout = (store: NotificationStore) => getTopBannerLayoutWithStore(store, MiniCalloutWrapper);
